import { useEffect } from 'react';

const cache = new Set();

const preloadImage = (src) => {
  if (cache.has(src)) return;
  cache.add(src);
  const img = new Image();
  img.src = src;
};

export const useImagePreloader = (images, eager = false) => {
  useEffect(() => {
    if (eager) {
      images.forEach(preloadImage);
    } else {
      // Stagger lazy loads to avoid network congestion
      images.forEach((src, i) => {
        setTimeout(() => preloadImage(src), i * 200);
      });
    }
  }, []); // eslint-disable-line
};

export { preloadImage };